module.exports = __webpack_public_path__ + "media/images/industry-1f5ed80baa22aef7b5a4d40f5b7e9399.svg";